import { Avatar, AvatarFallback, AvatarImage, BodyText } from "@/components/ui";
import { getInitials } from "@/lib/utils";

export const PatientAvatar = ({ name }: { name: string }) => (
  <Avatar className="w-8 h-8">
    <AvatarImage src={"placeholder_string"} />
    <AvatarFallback className="bg-accent-primary">
      <BodyText size="sm">{getInitials(name)}</BodyText>
    </AvatarFallback>
  </Avatar>
);
